const VERSIONS = {
  'program:immunization:service:immunization': {
    current: '2.0.0'
  },
  // This one is a pretty obscure testing thing:
  // it does not exist in prod
  'program:hiv-aids:service:warehouse-hiv-expiry': {
    current: '2.0.0'
  }
}
exports.VERSIONS = VERSIONS

const DEFAULT_VERSION = '1.0.0'
const DEFAULT_WAREHOUSE_VERSION = '2.0.0'
exports.DEFAULT_VERSION = DEFAULT_VERSION

exports.getVersion = function (serviceId) {
  return VERSIONS[serviceId]
    ? VERSIONS[serviceId].current
    : serviceId && serviceId.endsWith(':service:warehouse')
      ? DEFAULT_WAREHOUSE_VERSION
      : DEFAULT_VERSION
}
